import { paymentsModuleGuard, paymentsUpgradeGuard } from '@/utils/routeGuards/paymentsRouteGuard';

const routes = [
  {
    path: "/payments",
    component: () => import(/* webpackChunkName: "EventsIndex" */ "./views/autoBillingPage/AutobillingPage"),
    beforeEnter: paymentsModuleGuard,
    children: [
      {
        path: "auto-billing",
        name: "autoBillingPage",
        component: () => import(/* webpackChunkName: "EventsIndex" */ "./views/autoBillingPage/AutobillingPage")
      },
      {
        path: "*",
        redirect: { name: "autoBillingPage" }
      }
    ]
  },
  {
    path: "/external-error-dialog",
    component: () => import(/* webpackChunkName: "ExternalErrorDialog" */ "./views/externalErrorDialog/ExternalErrorDialog.vue"),
    beforeEnter: paymentsModuleGuard,
  },
  {
    path: "/payment_matcher",
    component: () => import(/* webpackChunkName: "PaymentMatcher" */ "./components/PaymentMatcher/PaymentMatcher"),
    beforeEnter: paymentsModuleGuard,
  },
  {
    path: "/product_order_dialog",
    component: () => import(/* webpackChunkName: "FullscreenProductOrderDialog" */ "../productOrder/components/productOrderDialog/FullscreenProductOrderDialog"),
    beforeEnter: paymentsModuleGuard,
  },
  {
    path: "/client_package_dialog",
    component: () => import(/* webpackChunkName: "FullscreenClientPackageDialog" */ "../packages/components/clientPackageDialog/FullscreenClientPackageDialog"),
    beforeEnter: paymentsModuleGuard,
  },
  {
    path: "/payments-upgrade",
    component: () => import(/* webpackChunkName: "upgrade" */ "./views/Upgrade"),
    beforeEnter: paymentsUpgradeGuard,
  },
  {
    path: "/payments-upgrade-page",
    component: () => import(/* webpackChunkName: "upgrade" */ "./views/UpgradePage"),
    beforeEnter: paymentsUpgradeGuard,
    props: route => ({
      title       : route?.query?.title || '',
      subtitle    : route?.query?.subtitle || '',
      button_text : route?.query?.button_text || '',
      bullet_first : route?.query?.bullet_first || '',
      bullet_second : route?.query?.bullet_second || '',
      bullet_third : route?.query?.bullet_third || '',
      image_filename: route?.query?.image_filename || '',
      custom_class: route?.query?.custom_class || '',
      mode: route?.query?.mode || 'dialog',
      is_mobile: route?.query?.is_mobile || false,
      learn_more_label: route?.query?.learn_more_label || '',
      learn_more_link_param: route?.query?.learn_more_link_param || '',
      learn_more_fallback_link: route?.query?.learn_more_fallback_link || ''
    })
  },
  {
    path: "/payments-trial-upsell",
    component: () => import(/* webpackChunkName: "upgrade" */ "./views/trialUpsell/PaymentsTrialUpsellDialog"),
    beforeEnter: paymentsUpgradeGuard,
  },
  {
    path: "/schedule-payment",
    component: () => import(/* webpackChunkName: "schedulePayment" */ "./views/scheduledPayments/FullScheduledPaymentsDialog"),
    beforeEnter: paymentsModuleGuard,
  },
  {
    path: "/payment-reports",
    component: () => import(/* webpackChunkName: "paymentReports" */ "./views/paymentReports/PaymentReports"),
    beforeEnter: paymentsModuleGuard,
  },
  {
    path: "/deposit-without-pg-dialog",
    name: "depositWithoutPgDialog",
    component: () => import(/* webpackChunkName: "depositWithoutPgDialog" */ "./components/depositWithoutPgDialog/depositWithoutPgDialog"),
    beforeEnter: paymentsModuleGuard,
  },
  {
    path: "/pdf-customization-notification",
    component: () => import(/* webpackChunkName: "pdfCustomizationNotification" */ "./components/PdfCustomizationNotification/PdfCustomizationNotification"),
    beforeEnter: paymentsModuleGuard,
  },
  {
    path: "/online-payment-without-pg-dialog",
    component: () => import(/* webpackChunkName: "onlinePaymentWithoutPgDialog" */ "./components/onlinePaymentWithoutPgDialog/onlinePaymentWithoutPgDialog"),
    beforeEnter: paymentsModuleGuard,
  },
  {
    path: "/add-payment-method-dialog",
    component: () => import(/* webpackChunkName: "addPaymentMethod" */ "./components/addPaymentMethodDialog/AddPaymentMethodDialog"),
    beforeEnter: paymentsModuleGuard,
  },
];

export default routes;
